module.exports = __webpack_public_path__ + "static/media/wowClassic.2b3cdbbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/games/wowClassic.jpg
// module id = 43
// module chunks = 0